import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';

export default function Card({
  children,
  tag,
  paddingClass,
  borderClass,
  className
}) {
  const Tag = tag ? tag : 'div';
  return (
    <Tag
      className={classnames(
        styles.card,
        typeof paddingClass === 'undefined' ? styles.padding : paddingClass,
        typeof borderClass === 'undefined' ? styles.border : borderClass,
        className
      )}
    >
      {children}
    </Tag>
  );
}
